const getters = {
  track: state => state.track,
  stateContinents: state=> state.track.stateContinents,
  stateCountries: state=> state.track.stateCountries,
  stateProducts: state=> state.track.stateProducts,
  stateWeightRestriction: state=> state.track.stateWeightRestriction,
  stateSizeRestriction: state=> state.track.stateSizeRestriction,
  stateValueRestrictionTerms: state=> state.track.stateValueRestrictionTerms,
  stateGeneralTerm: state=> state.track.stateGeneralTerm,
  news: state => state.news
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js